module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAA/klEQVR4nO2TsQ3CUAwFbfQZgYI5YC12YAgqFmEKGlZAECkrUDwKiJQiaX2R8k5KYafw6aQfUYikl6Y5V3qM2VCHl4ID0AI0DkAL0DgALUDjALQAjQPQAjQOQAvQOAAtQOMAtACNA9ACNA5AC9A4AC1A4wC0AI0D0AI0TdKh8N52Zr8v9Ogz8zkMKUlFh5fCJTNPw7D6J+AAtACNA9ACNC0ijoX3bhGxm9hf/18F/XhomXkvOhySPjO/ukqPMat/Ag5AC9A4AC1A4wC0AI0D0AI0DkAL0DgALUDjALQAjQPQAjQOQAvQOAAtQOMAtABNK773iIhuYv8u9jDG/PgCHfw1VUAANmcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus/PNG-plus-white.png
// module id = 96
// module chunks = 0